<template>
  <t-form ref="form" class="contact-form" @submit.prevent>
    <div class="contact-form__split">
      <div class="contact-form__column">
        <t-text-field
          v-model="name"
          class="contact-form__name"
          :placeholder="$t('field.name.placeholder')"
          autocomplete="name"
          :error-messages="nameErrors"
          @blur="validateName"
        />
      </div>
      <div class="contact-form__column">
        <t-text-field
          v-model="email"
          class="contact-form__email"
          :placeholder="$t('field.email.placeholder')"
          type="email"
          inputmode="email"
          autocomplete="email"
          :error-messages="emailErrors"
          @blur="validateEmail"
        />
      </div>
    </div>

    <t-textarea
      v-model="message"
      class="contact-form__message"
      :placeholder="$t('field.message.placeholder')"
      autocomplete="no-fill"
      :error-messages="messageErrors"
      @blur="validateMessage"
    />

    <t-btn
      id="submitContactForm"
      class="contact-form__submit-btn"
      color="primary"
      :disabled="submitBtnIsDisabled"
      @click="onSubmit"
    >
      {{ $t('global.contact-us') }}
    </t-btn>
  </t-form>
</template>

<script>
import ValidationRules from 'chimera/all/functions/ValidationRules'
import AbstractContactForm from './AbstractContactForm'

export default {
  name: 'ContactForm',

  extends: AbstractContactForm,

  props: {
    conversionName: {
      type: String,
      default: 'contact-form',
    },

    hubspotFormId: {
      type: String,
      default: 'd877c89c-3a7d-44f8-b7a8-c9cd37e2d537',
    },
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      name: '',
      nameErrors: [],
      nameRules: [
        (v) => !!v || this.$i18n.t('field.name.validation.required'),
        (v) =>
          this.hubspotErrors.filter((error) => error.field === 'firstname')
            .length === 0 || this.$i18n.t('field.name.validation.invalid'),
      ],
      message: '',
      messageErrors: [],
      messageRules: [
        (v) => !!v || this.$i18n.t('field.message.validation.required'),
        (v) =>
          this.hubspotErrors.filter((error) => error.field === 'message')
            .length === 0 || this.$i18n.t('field.message.validation.invalid'),
      ],
      email: '',
      emailErrors: [],
      emailRules: [
        (v) => !!v || this.$i18n.t('field.email.validation.required'),
        ...ValidationRules.isEmailFormat(
          this.$i18n.t('field.email.validation.invalid'),
        ),
        (v) =>
          this.hubspotErrors.filter((error) => error.field === 'email')
            .length === 0 || this.$i18n.t('field.email.validation.invalid'),
      ],
    }
  },

  methods: {
    /**
     * @returns {Array}
     */
    getFormFields() {
      return [
        {
          name: 'firstname',
          value: this.name,
        },
        {
          name: 'email',
          value: this.email,
        },
        {
          name: 'message',
          value: this.message,
        },
      ]
    },

    /**
     * Validate form
     *
     * @returns {boolean}
     */
    validateForm() {
      const allErrors = [
        ...this.validateName(),
        ...this.validateEmail(),
        ...this.validateMessage(),
      ]
      return allErrors.length === 0
    },

    /**
     * Validate name
     *
     * @returns {Array} errors
     */
    validateName() {
      this.nameErrors = ValidationRules.evaluate(this.nameRules, this.name)
      return this.nameErrors
    },

    /**
     * Validate email
     *
     * @returns {Array} errors
     */
    validateEmail() {
      this.emailErrors = ValidationRules.evaluate(this.emailRules, this.email)
      return this.emailErrors
    },

    /**
     * Validate message
     *
     * @returns {Array} errors
     */
    validateMessage() {
      this.messageErrors = ValidationRules.evaluate(
        this.messageRules,
        this.message,
      )
      return this.messageErrors
    },
  },
}
</script>
